import { DocumentProps, PDFViewer } from '@react-pdf/renderer';
import { JSXElementConstructor, ReactElement, SyntheticEvent } from 'react';
import { Drawer, Message } from 'rsuite';
import constants from '@helper/constants';
import { useTranslation } from 'react-i18next';

export type ResumeData = {
  jobTitle: string;
  email: string;
  name: string;
  experiences: Array<any>;
  skills: Array<string>;
};

type Props = {
  title: string | undefined;
  onClose: ((event: SyntheticEvent<Element, Event>) => void) | undefined;
  isOpen: boolean;
  children:
    | ReactElement<DocumentProps, string | JSXElementConstructor<any>>
    | undefined;
};

export default function ResumePreviewer({
  title,
  children,
  isOpen,
  onClose,
}: Props): any {
  const { t } = useTranslation();

  return (
    <Drawer size="calc(50%)" placement="right" open={isOpen} onClose={onClose}>
      <Drawer.Header>
        <Drawer.Title>
          {t(constants.translation.cvMaker.cvPreviewTitle)}
        </Drawer.Title>
        <Drawer.Actions />
      </Drawer.Header>
      <Drawer.Body>
        <Message className="mb-4" type="info" bordered showIcon>
          {title && (
            <>
              <b>{title}</b>
              <br />
            </>
          )}
          <div className="mt-2">
            <strong>Note:</strong> Some details are partially blurred and
            cropped for now. The clear version will be available once your
            payment is verified.
          </div>
        </Message>
        <PDFViewer showToolbar={false} width="100%" height="100%">
          {children}
        </PDFViewer>
      </Drawer.Body>
    </Drawer>
  );
}
